/**
 * Duplicates sizes from file _mixins.scss
 * @see public/wp-content/themes/comparison/assets/scss/common/_mixins.scss
 */
const DeviceSizes = Object.freeze({
	XXS: 320,
	XS: 576,
	SM: 768,
	MD: 1023,
	LG: 1200,
	XL: 1400,
	XXL: 1650,
});

export default DeviceSizes;
